module.exports = __webpack_public_path__ + "img/13.a34df4df.jpg";